import React, { useState } from "react";
import { BiCog } from "react-icons/bi";

function NavItem(props) {
  const [open, setOpen] = useState(false);

  return (
    <li className="nav-item">
      <a href="#" className="icon-button" onClick={() => setOpen(!open)}>
        <BiCog />
      </a>

      {open && props.children}
    </li>
  );
}

export default NavItem;
